module.exports = __webpack_public_path__ + "img/diamond-turn-right.0acc056f.svg";